<template>
    <div class="form-field">
        <div class="form-field__input">
            <label
                v-if="label"
                :for="id"
                class="form-field__label"
                :class="{ 'is-active': isLabelActive || phone }"
            >
                {{ label }}
            </label>

            <input
                :id="id"
                v-model="phone"
                type="tel"
                :placeholder="placeholder"
                :class="['input-field', { 'input-field_error': hasError }, { 'has-label': label }]"
                @input="applyPhoneMask"
                @focus="isLabelActive = true"
                @blur="isLabelActive = !!phone"
            />
        </div>

        <span v-if="hasError" class="form-field__error">
            {{ errorMessage }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, defineProps, defineEmits, onMounted } from 'vue';

    const props = defineProps<{
        modelValue?: string,
        placeholder?: string,
        label?: string,
        errorMessage?: string,
        id?: string,
    }>();

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string): void,
    }>();

    const phone = ref(props.modelValue || '+7 (___) ___-__-__');
    const isLabelActive = ref((props.modelValue || '').length > 0);
    const hasError = computed(() => !!props.errorMessage);

    watch(
        () => props.modelValue,
        (newValue) => {
            if (newValue !== phone.value) {
                phone.value = newValue || '+7 (___) ___-__-__';
            }
        },
    );

    function applyPhoneMask(): void {
        let digits = phone.value.replace(/\D/g, '');

        if (digits.startsWith('77')) {
            digits = digits.slice(1);
        }

        if (!digits.startsWith('7')) {
            digits = '7' + digits;
        }

        digits = digits.substring(0, 11);

        const maskedPhone = digits
            .replace(/^(\d)/, '+$1')
            .replace(/^(\+\d)(\d{3})/, '$1 ($2) ')
            .replace(/^(\+\d)\s\((\d{3})\)\s(\d{3})/, '$1 ($2) $3-')
            .replace(/^(\+\d)\s\((\d{3})\)\s(\d{3})-(\d{2})/, '$1 ($2) $3-$4-')
            .replace(/^(\+\d)\s\((\d{3})\)\s(\d{3})-(\d{2})-(\d{2})$/, '$1 ($2) $3-$4-$5');

        phone.value = maskedPhone;
        emit('update:modelValue', maskedPhone);
    }

    onMounted(() => {
        if (!props.modelValue) {
            phone.value = props.placeholder || '+7 (___) ___-__-__';
        }
    });
</script>

<style lang="scss" scoped>
    @use './UIPhoneInput.scss' as *;
</style>
